import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import { AppShell } from "@/components/shell/AppShell";
import Attention from "@/pages/Attention";
import Masuk from "@/pages/Masuk";
import Daftar from "@/pages/Daftar";
import VerifikasiEmail from "@/pages/VerifikasiEmail";
import Onboarding from "@/pages/Onboarding";
import Kebijakan from "@/pages/Kebijakan";
import LegalHakKonten from "@/pages/LegalHakKonten";
import LegalLaporanHak from "@/pages/LegalLaporanHak";
import Keputusan from "@/pages/Keputusan";
import KeputusanBaru from "@/pages/KeputusanBaru";
import Contoh from "@/pages/Contoh";
import Commit from "@/pages/Commit";
import Library from "@/pages/Library";
import Lembar from "@/pages/Lembar";
import LembarEditor from "@/pages/LembarEditor";
import LibraryNotes from "@/pages/LibraryNotes";
import LibrarySources from "@/pages/LibrarySources";
import LibraryBook from "@/pages/LibraryBook";
import Reader from "@/pages/Reader";
import Akun from "@/pages/Akun";
import LanggananMulai from "@/pages/LanggananMulai";
import LanggananHasil from "@/pages/LanggananHasil";
import Workspace from "@/pages/Workspace";
import Admin from "@/pages/Admin";
import AdminLibrary from "@/pages/AdminLibrary";
import { I18nProvider } from "@/i18n";
import { BetaNotice } from "@/components/ax/BetaNotice";
import { useAccountSession } from "@/hooks/useAccountSession";
import { SessionGate } from "@/components/auth/SessionGate";
import { RootIndex, RootShell } from "@/pages/Root";

function RequireAuth() {
  const session = useAccountSession();
  return <SessionGate session={session}><Outlet /></SessionGate>;
}

const router = createBrowserRouter([
  { path: "masuk", element: <Masuk /> },
  { path: "daftar", element: <Daftar /> },
  { path: "verifikasi-email", element: <VerifikasiEmail /> },
  { path: "onboarding", element: <Onboarding /> },
  { path: "kebijakan", element: <Kebijakan /> },
  { path: "legal/hak-konten", element: <LegalHakKonten /> },
  { path: "legal/laporan-hak", element: <LegalLaporanHak /> },
  {
    element: <RootShell />,
    children: [{ index: true, element: <RootIndex /> }],
  },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: "keputusan", element: <Keputusan /> },
          { path: "keputusan/baru", element: <KeputusanBaru /> },
          { path: "keputusan/contoh", element: <Contoh /> },
          { path: "keputusan/:id", element: <Workspace /> },
          { path: "keputusan/:id/commit", element: <Commit /> },
          { path: "library", element: <Library /> },
          { path: "lembar", element: <Lembar /> },
          { path: "lembar/:id", element: <LembarEditor /> },
          { path: "library/catatan", element: <LibraryNotes /> },
          { path: "library/sumber", element: <LibrarySources /> },
          { path: "library/:bookId", element: <LibraryBook /> },
          { path: "library/:bookId/bab/:chapterId", element: <Reader /> },
          { path: "akun", element: <Akun /> },
          { path: "admin", element: <Admin /> },
          { path: "admin/library", element: <AdminLibrary /> },
          { path: "langganan/mulai", element: <LanggananMulai /> },
          { path: "langganan/hasil", element: <LanggananHasil /> },
          { path: "*", element: <Attention /> },
        ],
      },
    ],
  },
]);

function App() {
  return (
    <I18nProvider>
      <BetaNotice />
      <RouterProvider router={router} />
    </I18nProvider>
  );
}

export default App;
